import { UserRoles } from '@/models/company';

/**
 * Roles that can reach company Settings — the sidebar's "Account" group.
 *
 * Managers are deliberately excluded: they are scoped to their own departments
 * and have no business changing company-wide configuration. Anything shown
 * outside Settings that carries the same authority (the Dashboard's salary-file
 * import, for example) must gate on this so the two cannot drift apart.
 *
 * Role is per-company — it comes from `BackofficeUserCompany.Role` for the
 * currently selected company, not from a single global role on the user.
 */
export const SETTINGS_ACCESS_ROLES = [UserRoles.Admin, UserRoles.SuperAdmin];

export const hasSettingsAccess = (role?: UserRoles) =>
    !!role && SETTINGS_ACCESS_ROLES.includes(role);
